<div class="statement-generations-container">
  <div class="card">
    <div class="card-header bg-header" style="background-color: rgb(105, 69, 175) !important;">
      <h4 class="text-white m-0">
        <mat-icon class="mr-2">history</mat-icon>
        Generated Statements
      </h4>
    </div>

    <div class="card-body">
      <!-- Search and Filters -->
      <div class="filters-section mb-4">
        <div class="row">
          <!-- Search -->
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Cerca</mat-label>
              <input
                matInput
                [(ngModel)]="searchTerm"
                (ngModelChange)="applyFilters()"
                placeholder="Cerca per nome...">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>

          <!-- Status Filter -->
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Stato</mat-label>
              <mat-select [(ngModel)]="statusFilter" (ngModelChange)="applyFilters()">
                <mat-option value="all">Tutti</mat-option>
                <mat-option value="completed">Completato</mat-option>
                <mat-option value="processing">In elaborazione</mat-option>
                <mat-option value="failed">Fallito</mat-option>
                <mat-option value="pending">In attesa</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Sort -->
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Ordina</mat-label>
              <mat-select [(ngModel)]="sortOrder" (ngModelChange)="applyFilters()">
                <mat-option value="newest">Più recenti</mat-option>
                <mat-option value="oldest">Meno recenti</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Refresh Button -->
          <div class="col-md-2">
            <button
              mat-raised-button
              color="primary"
              (click)="loadGenerations()"
              [disabled]="loading"
              class="w-100 mt-2"
              style="height: 48px;">
              <mat-icon>refresh</mat-icon>
              Aggiorna
            </button>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="loading" class="text-center py-5">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="mt-3">Caricamento in corso...</p>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && filteredGenerations.length === 0" class="text-center py-5">
        <mat-icon style="font-size: 4rem; height: 4rem; width: 4rem; color: #ccc;">history</mat-icon>
        <h5 class="mt-3">Nessuna generazione trovata</h5>
        <p class="text-muted">Non sono state ancora create generazioni di statement per questo progetto.</p>
      </div>

      <!-- Generations List -->
      <div *ngIf="!loading && filteredGenerations.length > 0" class="generations-list">
        <div
          *ngFor="let generation of filteredGenerations"
          class="generation-card"
          (click)="viewGeneration(generation)">

          <!-- Header Row -->
          <div class="generation-header">
            <div class="generation-name">
              <mat-icon class="mr-2">description</mat-icon>
              <strong>{{ generation.name }}</strong>
            </div>
            <div class="generation-status">
              <span class="badge" [ngClass]="getStatusBadgeClass(generation.status)">
                <mat-icon class="badge-icon">{{ getStatusIcon(generation.status) }}</mat-icon>
                {{ getStatusLabel(generation.status) }}
              </span>
            </div>
          </div>

          <!-- Details Row -->
          <div class="generation-details">
            <!-- Input Sources Count -->
            <div class="detail-item">
              <mat-icon class="detail-icon">input</mat-icon>
              <span>{{ generation.input_sources_count }} Documenti</span>
            </div>

            <!-- Generated Statements Count -->
            <div class="detail-item">
              <mat-icon class="detail-icon">fact_check</mat-icon>
              <span>{{ generation.generated_statements_count }} Statement</span>
            </div>

            <!-- Created Date -->
            <div class="detail-item">
              <mat-icon class="detail-icon">schedule</mat-icon>
              <span>{{ generation.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>

            <!-- Completed Date (if completed) -->
            <div class="detail-item" *ngIf="generation.completed_at">
              <mat-icon class="detail-icon">done</mat-icon>
              <span>Completato: {{ generation.completed_at | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>

          <!-- Progress Bar (for processing) -->
          <div *ngIf="generation.status === 'processing'" class="mt-2">
            <mat-progress-bar
              mode="determinate"
              [value]="generation.progress_percentage"
              color="accent">
            </mat-progress-bar>
            <small class="text-muted">{{ generation.progress_percentage }}% Completato</small>
          </div>

          <!-- Error Message (for failed) -->
          <div *ngIf="generation.status === 'failed' && generation.error_message" class="alert alert-danger mt-2 mb-0">
            <mat-icon class="mr-1">error</mat-icon>
            {{ generation.error_message }}
          </div>

          <!-- Actions (top-right) -->
          <div class="generation-actions">
            <button
              *ngIf="generation.status === 'processing'"
              mat-icon-button
              (click)="refreshStatus(generation, $event)"
              matTooltip="Aggiorna stato">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>

          <!-- Delete Button (bottom-right) -->
          <button
            mat-icon-button
            class="delete-generation-btn"
            (click)="deleteGeneration(generation, $event)"
            matTooltip="Elimina generazione">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
